import * as React from "react";

interface Props extends React.PropsWithChildren {}
export const CpLabelTooltip: React.FC<Props> = ({ children }) => {
  return <div className="flex items-center gap-2">{children}</div>;
};
